import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { FC, useState } from "react";
import AIBanner from "components/worth-it-builder/AIBanner";
import NothingToShow from "components/worth-it-builder/NothingToShow";
import { useRouter } from "next/router";

const AIBuilder: FC = () => {
  const [nothingToShow, setNothingToShow] = useState<boolean>(false);
  const router = useRouter();

  const [searchValue, setSearchValue] = useState("");
  const [budgetValue, setBudgetValue] = useState("");

  const getAiBuildParam = (param) => {
    const query = param?.trim();
    if (query) {
      router.push(`/ai-builder/search/${query}`);
    } else {
      setNothingToShow(true);
    }
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
  };

  return (
    <ShopLayout1 title={"AI BUILDER"} hasSearch={false} navbar={<Navbar />}>
      <AIBanner
        title={"AI BUILDER"}
        cover={"/assets/images/banners/aiBG_update.png"}
        hasSearch
        getAiBuildFunc={getAiBuildParam}
        searchValue={searchValue}
        setSearchValue={handleSearchChange}
        budgetValue={budgetValue}
        setBudgetValue={setBudgetValue}
      />

      <NothingToShow
        image={"/assets/images/kachi/KachiAi.gif"}
        title={"Enter Your Budget"}
        subtitle={
          nothingToShow
            ? "No result found"
            : "Try entering your budget in the search bar above"
        }
      />
    </ShopLayout1>
  );
};

export default AIBuilder;
